// extracted by mini-css-extract-plugin
module.exports = {"container":"Slider_container__3dACp","top":"Slider_top__3t6Ne","inputtextContainer":"Slider_inputtextContainer__2o8sc","slider":"Slider_slider__2ZUy0"};